import type { ProviderFunctionalComponent } from "../../types";

export const Provider: ProviderFunctionalComponent = ({ children }) => <>{children}</>;
